<app-hourglass-spinner [loadHourGlassLoader]="true" *ngIf="loadHourGlassLoader | async"></app-hourglass-spinner>
<app-loader *ngIf="loaderIcon | async"></app-loader>
<form [formGroup]="rentalForm" *ngIf="!payByBooth">
  <div class="row" *ngIf="!displayLayout">
    <div class="col-sm-12 col-md-12 col-lg-9 col-xl-9 text-start mt-2">
      <div class="row mb-2">
        <div class="col-6 text-start">
          <label class="heading">{{ 'Booth Rentals' | wordReplace }}</label>
        </div>
        <div class="col-6 text-end">
          <button type="button" class="btn btnAS me-1" (click)="onAddBoothClick()">ADD</button>
          <button type="button" class="btn btnAS" (click)="onLayoutClick()" *ngIf="!noLayout" i18n>Layout</button>
        </div>
      </div>
      <ejs-grid #gridMonthlyRental [dataSource]='selectedMonthlyBooths' [allowSorting]="true" class="e-grid-custom"
        height="300" (created)="created($event)" [gridLines]='lines' height="200" [allowSelection]="true"
        (rowSelected)='rowSelected($event)' allowSorting='true' [sortSettings]='sortOptions'>
        <e-columns>
          <e-column field="BoothNumber" headerText="{{ 'Booth #' | wordReplace }}" width="150"></e-column>
          <e-column field='Reservation' headerText='Res' textAlign='left' width=80>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Reservation" (change)="updateBoothData(data)">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='Drop' headerText='Drop' textAlign='left' width=80>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Drop" (change)="updateBoothData(data)">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          @if(noLayout == false){
          <e-column field="BoothType" headerText="{{ 'Booth Type' | wordReplace }}" width="150"></e-column>
          }
          <e-column field='Product' headerText='Product' width=200>
            <ng-template #template let-data>
              <span class="dataName">
                <select class="form-control" [(ngModel)]="data.Product" [ngModelOptions]="{standalone: true}"
                  (change)="productChange(data)">
                  <option *ngFor="let item of vendorProducts" [value]="item.ProductId">
                    {{item.ProductName}}</option>
                </select></span>
            </ng-template>
          </e-column>
          <e-column field='Sunday' headerText='Sun' width=70>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [(ngModel)]="data.Sunday"
                      [ngModelOptions]="{standalone: true}" disabled="true">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='Monday' headerText='Mon' width=70>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Monday" disabled="true">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='Tuesday' headerText='Tue' width=70>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Tuesday" disabled="true">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='Wednesday' headerText='Wed' width=70>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Wednesday" disabled="true">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='Thursday' headerText='Thu' width=70>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Thursday" disabled="true">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='Friday' headerText='Fri' width=70>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Friday" disabled="true">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='Saturday' headerText='Sat' width=70>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Saturday" disabled="true">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='RentalStartDate' headerText='Rental Start Date' width=200>
            <ng-template #template let-data>
              <span class="dataName">
                <select class="form-control" [(ngModel)]="data.RentalStartDate" [ngModelOptions]="{standalone: true}"
                  [disabled]="data.DiasbleStartDate" (blur)="updateBoothData(data)">
                  <option *ngFor="let item of data.StartDateList" [value]="item.startDate">
                    {{item.startDate}}</option>
                </select></span>
            </ng-template>
          </e-column>
          <e-column field='RentStartPeriod' headerText='Rent Start Period' width=200>
          </e-column>
          <e-column field='RentEndPeriod' headerText='Rent End Period' width=200>
            <ng-template #template let-data>
              <span class="dataName"
                (click)="$event.stopPropagation(); rentalExtension(data)">{{data.RentEndPeriod}}</span>
            </ng-template>
          </e-column>
          <e-column field='PerDiem' headerText='PerDiem' textAlign='left' width=100>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.PerDiem" (change)="updateBoothData(data)" [disabled]="!data.NewBooth">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='MktDays' headerText='Mkt Days' width=100>
          </e-column>
          <e-column field='PerDiemRent' headerText='PerDiem Rent' textAlign='Right' width=130>
          </e-column>
          <e-column field='Rent' headerText='Rent' textAlign="Right" width=120>
          </e-column>
          <e-column field='SalesTax' headerText='Sales Tax' textAlign="Right" width=120>
          </e-column>
          <e-column field='CityTax' headerText='Sec Level Tax' textAlign="Right" width=120>
          </e-column>
          <e-column field='January' headerText='Jan' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableJanMonth || !data.JanuaryMonthPresent" [(ngModel)]="data.January"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)"
                  (input)="allowOnlyRentAmount($event, data, 'January')" appRemoveCurrencyFormatting data-auto-blur>
              </span>
            </ng-template>
          </e-column>
          <e-column field='February' headerText='Feb' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableFebMonth || !data.FebruaryMonthPresent" [(ngModel)]="data.February"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'February')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='March' headerText='Mar' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableMarMonth || !data.MarchMonthPresent" [(ngModel)]="data.March"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'March')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='April' headerText='Apr' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableAprMonth || !data.AprilMonthPresent" [(ngModel)]="data.April"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'April')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='May' headerText='May' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableMayMonth || !data.MayMonthPresent" [(ngModel)]="data.May"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'May')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='June' headerText='Jun' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableJunMonth || !data.JuneMonthPresent" [(ngModel)]="data.June"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'June')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='July' headerText='Jul' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableJulMonth || !data.JulyMonthPresent" [(ngModel)]="data.July"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'July')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='August' headerText='Aug' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableAugMonth || !data.AugustMonthPresent" [(ngModel)]="data.August"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'August')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='September' headerText='Sep' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableSepMonth || !data.SeptemberMonthPresent" [(ngModel)]="data.September"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'September')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='October' headerText='Oct' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableOctMonth || !data.OctoberMonthPresent" [(ngModel)]="data.October"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'October')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='November' headerText='Nov' width=120>
            <ng-template #template let-data>
              <span class="dataName" *ngIf="overrideRent">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableNovMonth || !data.NovemberMonthPresent" [(ngModel)]="data.November"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'November')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='December' headerText='Dec' width=120>
            <ng-template #template let-data *ngIf="overrideRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1"
                  [disabled]="data.DisableDecMonth || !data.DecemberMonthPresent" [(ngModel)]="data.December"
                  [ngModelOptions]="{standalone: true}" (blur)="updateBoothData(data)" appRemoveCurrencyFormatting
                  data-auto-blur (input)="allowOnlyRentAmount($event, data, 'December')">
              </span>
            </ng-template>
          </e-column>
          <e-column field='RentalEndDate' headerText='Rental End Date' width=150>
          </e-column>
          <e-column headerText='Delete' field="Delete" width='100'>
            <ng-template #template let-data>
              <span class="Delete">
                <button class="colDelete" type="button" (click)="deleteSelectedBooth(data)"><img
                    src="./assets/images/delete.svg" class="img-fluid" style="max-width: 80% !important;" /></button>
              </span>
            </ng-template>
          </e-column>
        </e-columns>
      </ejs-grid>
      <div class="row my-2">
        <div class="col-6 text-start">
          <label class="heading">Other Rentals</label>
        </div>
        <div class="col-6 text-end">
          <button type="button" class="btn btnAS me-1" (click)="loadOtherItemsForBooking()">ADD</button>
        </div>
      </div>
      <ejs-grid #gridOtherRental [dataSource]='selectedOtherItems' [allowSorting]="true" class="e-grid-custom"
        height="300" (rowSelected)='rowOtherItemSelected($event)' allowSorting='true'
        [sortSettings]='sortOtherItemsOptions'>
        <e-columns>
          <e-column field='OtherItem' headerText='Item' textAlign='left' width=180>
          </e-column>
          <e-column field='Recurring' headerText='Rec' textAlign='left' width=80>
            <ng-template #template let-data>
              <span class="dataName">
                <div class="checkbox-wrapper mt-2">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" class="checkBoxClass" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="data.Recurring" (change)="updateOtherItem(data)">
                    <span i18n></span>
                  </label>
                </div>
              </span>
            </ng-template>
          </e-column>
          <e-column field='OtherItemCharge' headerText='Charge' textAlign='left' width=140>
            <ng-template #template let-data *ngIf="overrideOtherChargesRent">
              <span class="dataName">
                <input type="text" class="form-control text-right pr-1" [disabled]="!data.NewItem && data.Status != 'R'"
                  [(ngModel)]="data.OtherItemCharge" [ngModelOptions]="{standalone: true}"
                  (input)="allowOnlyRentAmount($event, data, 'OtherItemCharge', true)" (blur)="updateOtherItem(data)"
                  appRemoveCurrencyFormatting data-auto-blur>
              </span>
            </ng-template>
          </e-column>
          <e-column field='Quantity' headerText='Qty' width=100>
            <ng-template #template let-data>
              <span class="dataName">
                <input type="text" class="form-control" style="text-align: center;"
                  [disabled]="!data.NewItem && data.Status != 'R'" [(ngModel)]="data.Quantity"
                  [ngModelOptions]="{standalone: true}" (input)="limitQuantity($event, data,'grid')"
                  (blur)="updateOtherItem(data)" (keydown)="onCheckNumKeyPress($event)">
              </span>
            </ng-template>
          </e-column>
          <e-column field='BoothNo' headerText="{{ 'Booth#' | wordReplace }}" width=100>
          </e-column>
          <e-column field='RentalMonth' headerText='Month' width=240 textAlign='center'>
          </e-column>
          <e-column field='OtherItemtotal' headerText='Total' textAlign="Right" width=130>
          </e-column>
          <e-column field='SalesTax' headerText='Sales Tax' textAlign="Right" width=130>
          </e-column>
          <e-column field='CityTax' headerText='Sec Level Tax' textAlign="Right" width=130>
          </e-column>
          <e-column field='Reference' headerText='Reference' width=160>
            <ng-template #template let-data>
              <span class="dataName">
                <input type="text" class="form-control" (blur)="updateOtherItem(data)"
                  [disabled]="!data.NewItem && data.Status != 'R'" [(ngModel)]="data.Reference"
                  [ngModelOptions]="{standalone: true}" maxlength="50">
              </span>
            </ng-template>
          </e-column>
          <e-column headerText='Delete' field="Delete" width='100'>
            <ng-template #template let-data>
              <span class="Delete">
                <button type="button" class="colDelete" (click)="deleteOtherRentalCharges(data)"><img
                    src="./assets/images/delete.svg" class="img-fluid" style="max-width: 80% !important;" /></button>
              </span>
            </ng-template>
          </e-column>
        </e-columns>
      </ejs-grid>
    </div>

    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 text-start mt-2">
      <!-- Receipt & Contract Checkboxes -->
      <div class="border rounded p-3 mb-2">
        <div class="row row-cols-2 g-1" formGroupName="ReceiptAndContractSetting">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="dailyReceipt" formControlName="displayReceipt">
            <label class="form-check-label" for="dailyReceipt">Display Receipt</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="displayContract" formControlName="displayContract">
            <label class="form-check-label" for="displayContract">Display Contract</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="printReceipt" formControlName="printReceipt">
            <label class="form-check-label" for="printReceipt">Print Receipt</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="printContract" formControlName="printContract">
            <label class="form-check-label" for="printContract">Print Contract</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="emailReceipt" formControlName="emailReceipt">
            <label class="form-check-label" for="emailReceipt">Email Receipt</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="emailContract" formControlName="emailContract">
            <label class="form-check-label" for="emailContract">Email Contract</label>
          </div>
        </div>
      </div>

      <!-- Charges Section -->
      <div class="border rounded p-3" formGroupName="vendorBalances">
        <h6 class="fw-bold mb-2">Charges</h6>
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label class="form-label">Prior AR Balance</label>
            <input type="text" class="form-control text-end" formControlName="vendorPriorBalance"
              (keypress)="numberOnly($event)" readonly>
          </div>
          <div class="col-6">
            <label class="form-label">Rental Charges</label>
            <input type="text" class="form-control text-end" formControlName="totalRentalCharge"
              (keypress)="numberOnly($event)" readonly>
          </div>
          <div class="col-6">
            <label class="form-label">Other Charges</label>
            <input type="text" class="form-control text-end" formControlName="totalOtherRentalCharge"
              (keypress)="numberOnly($event)" readonly>
          </div>
          <div class="col-6" style="display: none;">
            <label class="form-label">Discount %</label>
            <input type="text" class="form-control" formControlName="totalDiscountCharge" readonly>
          </div>
          <div class="col-6" *ngIf="displaySalesTax || displayOtherChargeSalesTax">
            <label class="form-label">Sales Tax</label>
            <input type="text" class="form-control text-end" formControlName="totalSalesTax"
              (keypress)="numberOnly($event)" readonly>
          </div>
          <div class="col-6" *ngIf="displayCityTax || displayOtherChargeCityTax">
            <label class="form-label">{{secondTaxName}}</label>
            <input type="text" class="form-control text-end" formControlName="totalSecondLeveltax"
              (keypress)="numberOnly($event)" readonly>
          </div>
        </div>
        <div class="mb-1 fw-bold">TOTAL</div>
        <input type="text" class="form-control text-end" formControlName="totalCharge" (keypress)="numberOnly($event)"
          style="font-weight: bold;" readonly>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-end my-2">
        <button type="button" class="btn btn-success me-1" [disabled]="disablePayBooth()"
          (click)="saveCombinedMonthlyRental(true)" *ngIf="!dayendOrOpenCashNotSaved && !terminalNoSet">Save &
          Pay</button>
        <button type="button" class="btn btnAS me-1" (click)="saveCombinedMonthlyRental(false)"
          [disabled]="disableSaveRental()" *ngIf="!dayendOrOpenCashNotSaved && !terminalNoSet">Save</button>
        <button type="button" class="btn btn-orange me-1" (click)="cancelRental()">Cancel</button>
      </div>
    </div>
  </div>

  <div *ngIf="displayLayout">
    <app-ops-rental-layout [marketId]="marketId" [layoutParts]="layoutParts" [LayoutData]="MonthlyLayoutData"
      rentalType="CM" (selectedBoothsFromLayout)="selectedBoothsFromLayout($event)" (CloseLayout)="closeLayoutForm()"
      (removeBoothCharges)="removeBoothCharges($event)"></app-ops-rental-layout>
  </div>

  <!-- Modal -->
  <div class="modal fade" #modalAddNewMonthlyBooths id="modalAddNewMonthlyBooths" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Add Booking Monthly Rental</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" formGroupName="boothSearchScreen">
          <div class="row g-2">
            <div class="col-md-4">
              <label class="form-label">Rental Start</label>
              <select class="form-select" formControlName="rentalStartMonth" (change)="checkRentalMonths()">
                <option *ngFor="let item of monthlyMarketDays;" [value]="item.RentalMonths">
                  {{item.RentalMonths}}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Rental End</label>
              <select class="form-control" formControlName="rentalEndMonth" (change)="checkRentalMonths()">
                <option *ngFor="let item of monthlyMarketDays;" [value]="item.RentalMonths">
                  {{item.RentalMonths}}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Part</label>
              <select class="form-control" formControlName="boothParts" (change)="resetAvailableBooths()">
                <option *ngIf="!displayLayoutPopup" value="0">All Parts</option>
                <option *ngFor="let item of parts" [value]="item.PartId">{{item.PartDescription}}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Rental Start Date</label>
              <select class="form-control" formControlName="rentalStartDates1" (change)="resetAvailableBooths()">
                <option *ngFor="let item of rentalStartDates;" [value]="item.startDate">
                  {{item.startDate}}</option>
              </select>
            </div>

            <div class="col-md-4" *ngIf="!displayLayoutPopup">
              <label class="form-label">{{ 'Booth Number' | wordReplace }}</label>
              <div class="input-group">
                <input type="text" class="form-control" formControlName="srcBoothNumber">
                <button class="btn btn-dark pt-1 ms-2"
                  style="border-top-left-radius: 6px;border-bottom-left-radius: 6px;" type="button"
                  (click)="loadAvailableBooths()" [disabled]="!enableBoothSearch()">
                  <img src="./assets/images/search.svg" class="img-fluid" />
                </button>
              </div>
            </div>
          </div>

          <div class="card mt-2 p-3">
            <div class="d-flex flex-wrap gap-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="sunday" formControlName="marketDaysSunday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="sunday">Sunday</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="monday" formControlName="marketDaysMonday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="monday">Monday</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="tuesday" formControlName="marketDaysTuesday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="tuesday">Tuesday</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="wednesday" formControlName="marketDaysWednesday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="wednesday">Wednesday</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="thursday" formControlName="marketDaysThursday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="thursday">Thursday</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="friday" formControlName="marketDaysFriday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="friday">Friday</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="saturday" formControlName="marketDaysSaturday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="saturday">Saturday</label>
              </div>
            </div>
          </div>
          <div class="mt-2" *ngIf="!displayLayoutPopup">
            <h6>Available Rental</h6>
            <ejs-grid [dataSource]="allAvailableBooths" [allowPaging]="true" [allowSorting]="true"
              class="e-custom-grid">
              <e-columns>
                <e-column headerText="Select" width="100" textAlign="Center">
                  <ng-template #template let-data>
                    <input type="checkbox" (change)="selectBooth($event, data)" [(ngModel)]="data.boothChecked"
                      [ngModelOptions]="{standalone: true}" [attr.data-id]="data.BoothNumber" />
                  </ng-template>
                </e-column>
                <e-column field="BoothNumber" headerText="{{ 'Booth' | wordReplace }}" width="120"
                  textAlign="Left"></e-column>
                <e-column field="BoothDescription" headerText="Description" width="250" textAlign="Left"></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
        <div class="modal-footer">
          <button *ngIf="!displayLayoutPopup" type="button" class="btn btnAS me-1" (click)="addSelectedBoothsToGrid()"
            [disabled]="isMonthlyboothSelected" i18n>OK</button>
          <button *ngIf="displayLayoutPopup" type="button" class="btn btnAS me-1" (click)="openLayout()"
            [disabled]="!enableBoothSearch()" i18n>OK</button>
          <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal for Other Rentals -->
  <div class="modal fade" #modalAddOtherRentals id="modalAddOtherRentals" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Add Other Rentals</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" formGroupName="otherItemsScreen">
          <div class="row g-2 mb-2">
            <div class="col-md-3">
              <label class="form-label">Rental Month</label>
              <select class="form-control" formControlName="otherChargeMarketMonth"
                (change)="getBoothsAndItemsForOtherCharges()">
                <option *ngFor="let item of monthlyMarketDays;" [value]="item.RentalMonths">
                  {{item.RentalMonths}}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Search Value</label>
              <input type="text" class="form-control" formControlName="otherItemSearchText" (keyup)="searchOtherItem()"
                placeholder="Search Item">
            </div>
          </div>
          <h6 class="mt-4">Other Charges</h6>
          <div style="max-height: 300px; overflow-y: auto;">
            <table class="table table-bordered table-striped" style="width: 100%;">
              <thead style="background-color: black; color: white;">
                <tr>
                  <th style="width: 120px;"></th>
                  <th style="width: 150px;">Items</th>
                  <th style="width: 120px;">Rec</th>
                  <th style="width: 100px; text-align: right;">Charges</th>
                  <th style="width: 80px; text-align: right;">Qty</th>
                  <th style="width: 100px; text-align: right;">Total</th>
                  <th style="width: 200px;">Reference</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of otherRentalCharges">
                  <td>
                    <input type="checkbox" [(ngModel)]="data.isOtherItemChecked" [ngModelOptions]="{standalone: true}"
                      (change)="setDefaultRentalItem($event, data)">
                  </td>
                  <td>
                    {{ data.OtherItem }}
                  </td>
                  <td>
                    <input type="checkbox" class="checkBoxClass" [(ngModel)]="data.Recurring"
                      [ngModelOptions]="{standalone: true}" (change)="otherItemUpdate(data)"
                      [disabled]="!data.isOtherItemChecked">
                  </td>
                  <td style="text-align: right;">
                    <input type="text" class="form-control text-right pr-1" [(ngModel)]="data.OtherItemCharge"
                      [ngModelOptions]="{standalone: true}" (change)="otherItemUpdate(data)"
                      (input)="allowOnlyRentAmount($event, data, 'OtherItemCharge', true)"
                      [disabled]="!data.isOtherItemChecked">
                  </td>
                  <td style="text-align: right;">
                    <input type="text" inputmode="numeric" class="form-control" [(ngModel)]="data.Quantity"
                      [ngModelOptions]="{standalone: true}" (input)="limitQuantity($event, data)"
                      (blur)="setDefaultQuantity($event, data)" [disabled]="!data.isOtherItemChecked">
                  </td>
                  <td style="text-align: right;">
                    {{ data.OtherItemtotal }}
                  </td>
                  <td>
                    <input type="text" class="form-control" [(ngModel)]="data.Reference"
                      [ngModelOptions]="{standalone: true}" (keyup)="otherItemUpdate(data)"
                      [disabled]="!data.isOtherItemChecked" maxlength="50">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btnAS me-1" (click)="addOtherCharges()" [disabled]="disableOtherCharge()"
            i18n>OK</button>
          <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="rentalExtensionModal" #rentalExtensionModal tabindex="-1"
    aria-labelledby="rentalExtensionLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content" formGroupName="RentalExtensionForm">
        <div class="modal-header">
          <h5 class="modal-title" id="rentalExtensionLabel">Combined Monthly Booking Extension</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="closeRentalExtendPopup()"></button>
        </div>

        <div class="modal-body">
          <!-- Booth Number Display -->
          <div class="row mx-0 mt-1">
            <div class="col-4 fw-bold">{{ 'Booth Number' | wordReplace }}</div>
            <div class="col-8 text-end fw-bold">
              <span>{{ BoothNumber | wordReplace}}</span>
            </div>
          </div>

          <div class="row mt-3 mx-2 rentExtension">
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="sunday" formControlName="marketDaysSunday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="sunday">Sunday</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="monday" formControlName="marketDaysMonday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="monday">Monday</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="tuesday" formControlName="marketDaysTuesday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="tuesday">Tuesday</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="wednesday" formControlName="marketDaysWednesday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="wednesday">Wednesday</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="thursday" formControlName="marketDaysThursday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="thursday">Thursday</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="friday" formControlName="marketDaysFriday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="friday">Friday</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="saturday" formControlName="marketDaysSaturday"
                  (change)="checkMarketDay()">
                <label class="form-check-label" for="saturday">Saturday</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Extend To -->
        <div class="row mt-3 mr-2 ml-2 mb-2">
          <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-left">
            <label i18n>Extend To</label>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left">
            <select class="form-control" formControlName="rentalEndMonth">
              <ng-container *ngFor="let item of monthlyMarketDays; let i = index">
                <option *ngIf="i > rentEndPeriodIndex" [ngValue]="item.RentalMonths">
                  {{ item.RentalMonths }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-orange" data-bs-dismiss="modal"
            (click)="closeRentalExtendPopup()">Cancel</button>
          <button type="button" class="btn btnAS me-1" (click)="extendRental()">Continue</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- Receipt Modal -->
<div class="modal fade" id="printReceiptPopup" tabindex="-1" aria-labelledby="printReceiptModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="printReceiptModalLabel">Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- Loading Spinner -->
        <div class="text-center py-5" *ngIf="loading; else pdfViewReceipt">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-muted">Loading receipt...</p>
        </div>

        <!-- PDF View -->
        <ng-template #pdfViewReceipt>
          <iframe *ngIf="receiptUrl" [src]="receiptUrl" width="100%" height="500px" frameborder="0"></iframe>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Contract Modal -->
<div class="modal fade" id="printContractPopup" tabindex="-1" aria-labelledby="printContractModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="printContractModalLabel">Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- Loading Spinner -->
        <div class="text-center py-5" *ngIf="loading; else pdfViewContract">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-muted">Loading contract...</p>
        </div>

        <!-- PDF View -->
        <ng-template #pdfViewContract>
          <iframe *ngIf="contractUrl" [src]="contractUrl" width="100%" height="500px" frameborder="0"></iframe>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="payByBoothModal" #payByBoothModal tabindex="-1" aria-labelledby="payByBoothModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="payByBoothModalLabel">Payments</h5>
        <button type="button" class="btn-close" (click)="closePayByBoothPopup()"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="payByBooth">
          <app-rental-pay-bybooth [rentalData]="rentalModel" [Dues]="Dues" rentalType="4" [vendorId]="vendorId"
            [PriorBalance]="priorBalance" (closePayByBooth)="closePayByBooth($event)"
            (cancelPayByBooth)="cancelPayByBooth($event)"
            (paymentCompleted)="HandleReceipts($event)"></app-rental-pay-bybooth>
        </div>
      </div>
    </div>
  </div>
</div>